import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  quantity: 0,
  total: 0,
  openPayment: false
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
      addProduct: (state, action) => {
        state.quantity += action.payload.quantity;
        const ID = state.products.length;
        state.products.push({...action.payload , ID: ID + 1});
        state.total += action.payload.price * action.payload.quantity;
      },
      incrementQuantity: (state, action) => {
        const item = state.products.find((item) => item.ID === action.payload);
        item.quantity++;
        state.total += item.price
      },
      decrementQuantity: (state, action) => {
        const item = state.products.find((item) => item.ID === action.payload);
        if (item.quantity === 1) {
          item.quantity = 1
        } else {
          item.quantity--;
          state.total -= item.price
        }
      },
      changeColor: (state, action) => {
        const item = state.products.find((item) => item.ID === action.payload.ID);
        item.selectedColor = action.payload.color;
      },
      changeSize: (state, action) => {
        const item = state.products.find((item) => item.ID === action.payload.ID);
        item.selectedSize = action.payload.size;
      },
      removeProduct: (state, action) => {
      const newProducts = state.products.filter(item=> item.ID !== action.payload.ID );
      state.products = newProducts;
      state.quantity -= action.payload.quantity;
      state.total -= action.payload.price * action.payload.quantity;
      if (state.products.length === 0 ){ state.total = 0}
      },
      openPayment: (state) => {
      state.openPayment = !state.openPayment;
      },
      clearCart: (state) => {
        state.products = [];
        state.quantity = 0;
        state.total = 0
      }
  },
});

export const { addProduct, incrementQuantity, decrementQuantity, changeColor, changeSize, removeProduct, openPayment, clearCart } = cartSlice.actions;

export default cartSlice.reducer;
